export enum MapmakerPrintServiceId {
  WALGREENS = "WALGREENS",
  DOWNLOAD = "DOWNLOAD",
  STICKERS = "STICKERS",
}
